
/* eslint-disable */
/**
 * 该文件是为了按需加载，剔除掉了一些不需要的框架组件。
 * 减少了编译支持库包大小
 *
 * 当需要更多组件依赖时，在该文件加入即可
 */
import Vue from 'vue'
import {
  ConfigProvider,
  Layout,
  Input,
  InputNumber,
  Button,
  Switch,
  Radio,
  Checkbox,
  Select,
  Card,
  Collapse,
  Form,
  Row,
  Col,
  Table,
  Tabs,
  Icon,
  Badge,
  Popover,
  Dropdown,
  List,
  Avatar,
  Breadcrumb,
  Steps,
  Spin,
  Menu,
  Drawer,
  Tooltip,
  Alert,
  Tag,
  Divider,
  DatePicker,
  TimePicker,
  Upload,
  Progress,
  Skeleton,
  Popconfirm,
  message,
  notification,
  Result,
  Tree,
  Pagination,
  Empty,
  TreeSelect,
  FormModel
} from 'ant-design-vue'
import PageLoading from '@/components/PageLoading'
import Storage from 'vue-ls'

Vue.use(VueStorage, {
  storage: 'local'
})

const SassIcon = Icon.createFromIconfontCN({
  // scriptUrl: '//at.alicdn.com/t/font_2222830_02gr1gtjmock.js'
  // 项目地址：https://www.iconfont.cn/manage/index?manage_type=myprojects&projectId=2632810
  scriptUrl: '//at.alicdn.com/t/font_2632810_hrovo6ypsod.js'
})

import Modal from '@/components/antModal'
Vue.component('SassIcon', SassIcon)
Vue.use(ConfigProvider)
Vue.use(Layout)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Card)
Vue.use(Collapse)
Vue.use(Form)
Vue.use(Row)
Vue.use(Col)
Vue.use(Modal)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Badge)
Vue.use(Popover)
Vue.use(Dropdown)
Vue.use(List)
Vue.use(Avatar)
Vue.use(Breadcrumb)
Vue.use(Steps)
Vue.use(Spin)
Vue.use(Menu)
Vue.use(Drawer)
Vue.use(Tooltip)
Vue.use(Alert)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Skeleton)
Vue.use(Popconfirm)
Vue.use(notification)
Vue.use(Result)
Vue.use(Tree)
Vue.use(Pagination)
Vue.use(Empty)
Vue.use(TreeSelect)
Vue.use(FormModel)

Vue.use(PageLoading)

import { Modal as AModal } from 'ant-design-vue'
Vue.prototype.$confirm = AModal.confirm
Vue.prototype.$message = message
Vue.prototype.$notification = notification
Vue.prototype.$info = AModal.info
Vue.prototype.$success = AModal.success
Vue.prototype.$error = AModal.error
Vue.prototype.$warning = AModal.warning

/**
 * @清空弹出层
 */
 function clearPopups () {
  AModal.destroyAll()
  const modalList = [].slice.call(document.querySelectorAll('.ant-modal-root'))
  const drawerList = [].slice.call(document.querySelectorAll('.ant-drawer'))
  const popupList = [...modalList, ...drawerList]
  if (!popupList.length) return
  popupList.forEach(el => {
    el.parentNode.removeChild(el)
  })
}

Vue.prototype.$destroyAll = clearPopups
